import {
  Flex,
  // useIsMobileView,
  Text,
  color,
  typography,
  useColorMode,
} from 'deepstash-ui';
import React from 'react';
import LandingStartTrialButton from 'src/page-components/landing/components-v2/LandingStartTrialButton';

const TITLE = 'Start collection & level up your skills.';

interface CollectionSignUpSectionProps {}

const CollectionSignUpSection: React.FC<
  CollectionSignUpSectionProps
> = ({}) => {
  // const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  // TODO No Trial Changes
  // const { stripePrices, requestStatus } = useStripePrices({
  //   requestNsi: true,
  // });

  // const freeTrialSubscription = stripePrices?.subscriptions['1 YEAR'];

  // const normalizedPrice = `$${freeTrialSubscription?.pricePerMonth}/month`;

  return (
    <Flex w="100%" flexDirection="column" alignItems="center">
      <Text
        {...typography.primaryHeadingFonts.medium.semiBold}
        color={color[colorMode].text}
        textAlign="center"
      >
        {TITLE}
      </Text>
      <Text
        {...typography.primaryTextFonts.large.regular}
        color={color[colorMode].textSecondary}
        textAlign="center"
        mt={8}
      >
        {/* TODO No Trial Changes */}
        {/* {requestStatus === 'success'
          ? `Try first week for free, then ${normalizedPrice}.`
          : ''} */}
        Embark on your personal growth journey with Deepstash Pro.
      </Text>
      <LandingStartTrialButton
        landingLocation={'collection-first-section'}
        mt={16}
        px={80}
      />
    </Flex>
  );
};

export default CollectionSignUpSection;
